import * as PLANNING_ALERT from "../files/alert/planningAlert.i18n";
import * as TRAINING_ACTIVITY_ALERT from "../files/alert/trainingActivityAlert.i18n";
import * as TRAINING_COURSE_ALERT from "../files/alert/trainingCourseAlert.i18n";


export const trainingCourseAlert = TRAINING_COURSE_ALERT;
export const planningAlert = PLANNING_ALERT;
export const trainingActivityAlert = TRAINING_ACTIVITY_ALERT;